export function isNumeric(value) {
    return /^-?\d+$/.test(value);
}

export function backspace(str) {
    return str.slice(0, -1);
}